export const GET_PRODUCTDATA = 'GET_PRODUCTDATA';
export const SET_PRODUCTDATA = 'SET_PRODUCTDATA';
export const GET_PRODUCTBYID = 'GET_PRODUCTBYID';
export const SET_PRODUCT = 'SET_PRODUCT';
export const GET_CREATEUPDATEPRODUCT = 'GET_CREATEUPDATEPRODUCT';
export const GET_SAVEDPRODUCTFLAG = 'GET_SAVEDPRODUCTFLAG';
export const SET_SAVEDPRODUCTFLAG = 'SET_SAVEDPRODUCTFLAG';
export const SET_ERRORPRODUCT = 'SET_ERRORPRODUCT';
export const SET_PRODUCTNAME = 'SET_PRODUCTNAME';